async function getCart() {
  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  return res.json();
}

async function refreshDrawer() {
  const drawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer');

  if (drawer && typeof drawer.renderContents === 'function') {
    const cart = await getCart();
    drawer.renderContents(cart);
    return;
  }

  if (drawer && typeof drawer.update === 'function') {
    const cart = await getCart();
    drawer.update(cart);
    return;
  }

  const cart = await getCart();
  document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
}

async function getVariantAvailability(variantId) {
  // Tenta ir buscar o JSON do produto da variante via endpoint "variants"
  // Este endpoint existe em muitas lojas: /variants/<id>.js
  const res = await fetch(`/variants/${variantId}.js`, { headers: { 'Accept': 'application/json' } });

  if (!res.ok) return null; // não consegui validar
  const variant = await res.json();

  // variant.available costuma existir neste endpoint
  return typeof variant.available === 'boolean' ? variant.available : null;
}

document.addEventListener('change', async (e) => {
  const checkbox = e.target;
  if (!checkbox.matches('.cart-gift-wrap__checkbox')) return;

  const variantId = Number(checkbox.dataset.giftVariantId);
  const lineKey = checkbox.dataset.giftLineKey;

  if (!variantId) return;

  checkbox.disabled = true;

  try {
    if (checkbox.checked) {
      // 1) validar disponibilidade antes de adicionar
      const available = await getVariantAvailability(variantId);

      if (available === false) {
        // Variante está mesmo indisponível
        checkbox.checked = false;
        alert('Sold out.');
        return;
      }

      // 2) adicionar ao carrinho
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      // 3) se falhar (ex: 422), reverter checkbox
      if (!addRes.ok) {
        const err = await addRes.json().catch(() => null);
        checkbox.checked = false;

        // mensagem amigável
        const msg =
          err?.description ||
          err?.message ||
          'Sold out.';
        alert(msg);

        return;
      }
    } else {
      // remover (preferir lineKey)
      const payload = lineKey
        ? { id: lineKey, quantity: 0 }
        : { id: variantId, quantity: 0 };

      const changeRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!changeRes.ok) {
        checkbox.checked = true; // rollback
        alert('Não foi possível remover a opção. Tenta novamente.');
        return;
      }
    }

    await refreshDrawer();
  } catch (err) {
    console.error('Gift wrap toggle failed', err);
    checkbox.checked = !checkbox.checked; // rollback
  } finally {
    checkbox.disabled = false;
  }
});
